import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mutate-entity-modal-body" }
const _hoisted_2 = {
  key: 0,
  class: "loading apollo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormItem = _resolveComponent("FormItem")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onClose: _ctx.closeModal,
    class: "add-offered"
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("titles.offered.add")), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"])),
          id: "mutateOfferedForm"
        }, [
          _createVNode(_component_FormItem, {
            input: _ctx.formatPrice(_ctx.amountNet),
            "onUpdate:input": _cache[0] || (_cache[0] = (val) => (_ctx.amountNet = _ctx.parsePriceToCents(val))),
            errors: _ctx.v$.amountNet.$errors,
            label: _ctx.t(`labels.offered.amountNet`),
            name: "offered-amount-net"
          }, null, 8, ["input", "errors", "label"]),
          _createVNode(_component_FormItem, {
            input: _ctx.date,
            "onUpdate:input": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
            errors: _ctx.v$.date.$errors,
            label: _ctx.t(`labels.offered.date`),
            "input-type": "date",
            name: "offered-date"
          }, null, 8, ["input", "errors", "label"]),
          _createVNode(_component_FormItem, {
            input: _ctx.comment,
            "onUpdate:input": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.comment) = $event)),
            label: _ctx.t(`labels.offered.comment`),
            name: "offered-comment"
          }, null, 8, ["input", "label"])
        ], 32)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.t("loading")), 1))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_BasicButton, {
        type: "submit",
        form: "mutateOfferedForm",
        value: _ctx.t('buttons.offered.add'),
        disabled: _ctx.loading,
        class: "add-offered-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("buttons.offered.add")), 1)
        ]),
        _: 1
      }, 8, ["value", "disabled"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}